import { unwrap } from '../../utils/ChangeSpy';

const typeHasParent = ['DivPri', 'DivLBO', 'DivPub', 'DivVC', 'DivNFP', 'JV', 'DivFor'];

export default function(field) {
  return typeHasParent.indexOf(unwrap(field)) !== -1;
}
